import moment from "moment/moment";

const addStr = (str, index, stringToAdd) => str.substring(0, index) + stringToAdd + str.substring(index, str.length);

const formatSentUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;

  const formats = 'if_w_gt_1000/c_scale,w_1000/if_end/q_auto';
  return originalUrl.replace('/image/upload', `/image/upload/${formats}`);
};

const formatSelectedFastAnswerUrl = (originalUrl, fileType) => {
  if (fileType === 'file' || fileType === 'audio') return originalUrl;

  const formats = 'c_scale,w_50/q_auto';
  return originalUrl.replace('/image/upload', `/image/upload/${formats}`);
};

const formatSelectedProductUrl = (originalUrl) => {
  if (!originalUrl) return originalUrl;

  const formats = 'c_scale,w_50/q_auto';
  return originalUrl.replace('/image/upload', `/image/upload/${formats}`);
};

// Esto debería ser un validador no una función de string
const onlyInteger = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

const inputNameFormat = (_name) => /^[a-zA-Z][a-zA-Z0-9_']{0,}$/.test(_name);

const strPadStart = (number = 1, mask = '6') => String(number).padStart(mask, '0');

const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
};

const getInitialsFromFullName = (fullName) => {
  const names = fullName.split(' ');

  const firstInitialArray = Array.from(names[0] || '');
  const firstInitial = firstInitialArray[0] || '';

  let secondInitial = '';
  if (names.length > 1) {
    const secondNameArray = Array.from(names[1]);
    secondInitial = secondNameArray[0] || '';
  }

  const initials = `${firstInitial}${secondInitial}`;
  return initials;
};

const validateDateFormat = (date) => {
  return date && moment(date).isValid();
};

const parseCustomerRelatedFieldDate = (data) => {
  if (!data) return null;
  const parsed = moment(data, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  return parsed.isValid() ? parsed.toDate() : null;
};

export default {
  addStr,
  formatSentUrl,
  formatSelectedFastAnswerUrl,
  onlyInteger,
  formatSelectedProductUrl,
  inputNameFormat,
  strPadStart,
  validateEmail,
  getInitialsFromFullName,
  validateDateFormat,
  parseCustomerRelatedFieldDate
};
